<script setup lang="ts">
import { provide, ref, type Ref } from 'vue'
import { useToast } from 'vue-fomantic-ui'
import { useSyncStore } from '@/stores/sync'
import { ContainerStatus, type Container } from '@/models/Container'
import { ActionType } from '@/actions/Action'

const { toast } = useToast()
const syncStore = useSyncStore()

const container: Ref<Container | null> = ref(null)
provide('container', container)

let syncInProgress = false

const sync = async (weight: number) => {
  if (!container.value || syncInProgress) return
  syncInProgress = true

  await syncStore.syncAction({
    type: ActionType.ContainerWeighing,
    containerCode: container.value.code,
    payload: { weight }
  })

  toast({
    position: 'centered',
    message: `Le bac ${container.value.code} a été pesé.`,
    type: 'success',
  })

  container.value.status = ContainerStatus.Weighted
  container.value = null

  syncInProgress = false
}
provide('sync', sync)
</script>

<template>
  <RouterView />
</template>
